import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AbstractPageComponent, Country, FoehnSelectComponent, SdkDictionaryService } from '@dsivd/prestations-ng';
import { Subscription } from 'rxjs';

import { BusinessForm } from '../../model/business-form';
import { CadorReference } from '../../model/cador-reference';
import { PersonNomenclature } from '../../model/person-nomenclature';
import { Personne } from '../../model/personne';
import { RefCadorService } from '../../services/ref-cador/ref-cador.service';
import { RefInfService } from '../../services/ref-inf/ref-inf.service';
import { ElementUtils } from '../../utils/element.utils';

@Component({
    templateUrl: './information-applicant-page.component.html'
})
export class InformationApplicantPageComponent extends AbstractPageComponent<BusinessForm> implements OnInit, OnDestroy, AfterViewInit {

    private static SWISS_ISO_ID = 'CH';

    @ViewChild('foehnSelectNationality')
        foehnSelectNationality: FoehnSelectComponent;

    wholeValue = ElementUtils.wholeValue;

    civilities: PersonNomenclature[];
    civilStatuses: PersonNomenclature[];
    nationalities: Country[];
    countries: Country[];
    residencePermits: CadorReference[];
    contactPreferences: CadorReference[];
    personne: Personne;
    isSwissNationalitySelected = false;

    private selectNationalitySubscription: Subscription;

    constructor(
        protected activatedRoute: ActivatedRoute,
        private dictionaryService: SdkDictionaryService,
        private refInfService: RefInfService,
        private refCadorService: RefCadorService
    ) {
        super(activatedRoute);

        this.civilities = this.refInfService.getCivilitiesSync();
        this.civilStatuses = this.refInfService.getMaritalStatusesSync();
        this.countries = this.refInfService.getCountriesSync();
        this.nationalities = this.refInfService.getCountriesSync();

        // serait mieux d'utiliser celui-ci...
        // this.residencePermits = this.refInfService.getResidencePermitsSync();
        this.residencePermits = this.refCadorService.getPermisSejourSync();
        this.contactPreferences = this.refCadorService.getContactPreferencesSync();

    }

    ngOnInit(): void {
        super.ngOnInit();
        super.setPageTitle(this.dictionaryService.getKeySync('information-applicant.title'));
    }

    ngAfterViewInit(): void {
        super.ngAfterViewInit();

        this.selectNationalitySubscription = this.foehnSelectNationality.modelChange
            .subscribe((model: Country) => {

                this.isSwissNationalitySelected = model === null || typeof model === 'undefined' ?
                    false : model.iso2Id === InformationApplicantPageComponent.SWISS_ISO_ID;

                if (this.isSwissNationalitySelected) {
                    this.form.informationApplicant.dateOfArrival = null;
                    // this.form.informationApplicant.nativeCountry = null;
                    this.form.informationApplicant.residencePermit = null;

                    // TODO : Clear business errors on those fields if it exists
                    // Do ValidationHandlerService.updateErrors([])
                }
            });
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();

        if (this.selectNationalitySubscription) {
            this.selectNationalitySubscription.unsubscribe();
        }
    }

    newForm(): BusinessForm {
        return new BusinessForm();
    }

    send(goToNextPage?: boolean): void {
        this.beforeSend(false, goToNextPage);
    }

    private beforeSend(previous: boolean, goToNextPage: boolean): void {
        // demande perso ?? recopie des infos du bénéficiaire dans celles du demandeur
        if (this.form.requestOrigin.isSelfRequest) {
            // @indice 0 : c'est toujours le demandeur
            this.personne = this.form.personnesReference.personnesReferences[0];
            this.personne.telephone = this.form.informationApplicant.phone;
            this.personne.adresse = { ...this.form.informationApplicant.address };
        }

        if (previous) {
            super.previous();
        } else {
            super.send(goToNextPage);
        }
    }
}
